import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to top on pathname change EXCEPT when only the language prefix changes
 * (e.g. /ar -> /en, or /ar/privacy -> /en/privacy).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prev = useRef(pathname);

  useEffect(() => {
    const stripLang = (p) => p.replace(/^\/(ar|en)(?=\/|$)/, "");
    const prevBase = stripLang(prev.current);
    const currBase = stripLang(pathname);

    if (prevBase !== currBase) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
    prev.current = pathname;
  }, [pathname]);

  return null;
}
